const searchBoxMessages = {
    validationErrorMessages: {
        invalidOrigin:"Invalid value for Origin.",
        invalidDestination:"Invalid value for Destination.",
        invalidDepartureDate:"Invalid date of Departure.",
        invalidReturnDate:"Invalid date of Returning",
        departureDateLaterThanReturnDate:"Date of departure cannot be later than date of returning.",
        passengerNoNotSpecified:"There must be at least one adult passenger.",
        invalidAirline:"Invalid value for Airline."
    },
   
};

export default searchBoxMessages;